<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card class="strpied-tabled-with-hover" body-classes="table-responsive">
            <template slot="header">
              <div class="d-flex align-items-center justify-content-between">
                <h4 class="card-title mb-0"><i class="icon-svg icon-tag"></i>{{ $t('Etiquetas') }}</h4>
                <button
                    class="btn btn-add-outline btn-sm flex-shrink-0 ml-3"
                    @click="openCreateModal">
                  <i class="icon-svg icon-plus"></i> {{ $t('nuevo') }}
                </button>
              </div>
            </template>

            <!-- Tabla manual en lugar de l-table -->
            <div class="pl-4">
              <table class="table table-hover table-striped">
                <thead>
                <tr>
                  <th class="col-id">ID</th>
                  <th>{{ $t('Titulo') }}</th>
                  <th>{{ $t('Estilo') }}</th>
                  <th>{{ $t('Categoria') }}</th>
                  <th class="text-right">{{ $t('Acciones') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td class="col-id">{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                      <span class="tag-badge" :class="item.css_class">
                        {{ item.name }}
                      </span>
                  </td>
                  <td>{{ item.category }}</td>
                  <td>
                    <div class="d-flex justify-content-end">
                      <a href="#" v-tooltip="$t('edit')" @click="editById(item.id)" class="btn btn-edit-outline"><i class="icon-svg icon-edit"></i></a>
                      <a href="#" v-tooltip="$t('Eliminar')" @click="deleteTag(item.id)" class="btn btn-delete-outline"><i class="icon-svg icon-trash"></i></a>
                    </div>

                    <!--<button
                        class="btn btn-sm btn-warning"
                        @click="editById(item.id)">
                      <i class="fa fa-edit"></i>
                    </button>
                    <button
                        class="btn btn-sm btn-danger"
                        @click="deleteTag(item.id)">
                      <i class="fa fa-trash"></i>
                    </button>-->
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </card>

          <!-- Modal para crear/editar -->
          <div
              class="modal fade cd-modal"
              id="tagModal"
              tabindex="-1"
              role="dialog"
              :class="{ 'show': showModal }"
              :style="{ display: showModal ? 'block' : 'none' }">
            <div class="modal-dialog modal-lg" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">
                    {{ formData.id ? $t('Editar Etiqueta') : $t('Nueva Etiqueta') }}
                  </h5>
                  <button type="button" class="close" @click="closeModal">
                    <span>&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form @submit.prevent="saveTag">
                    <div class="form-group">
                      <label class="cd-form-label" for="tagName">{{ $t('Titulo') }}</label>
                      <input
                          id="tagName"
                          v-model="formData.name"
                          type="text"
                          class="form-control"
                          required>
                    </div>


                    <div class="form-group">
                      <label class="cd-form-label" for="tagCategory">{{ $t('Categoria') }}</label>
                      <input
                          id="tagCategory"
                          v-model="formData.category"
                          type="text"
                          class="form-control"
                          required>
                    </div>

                    <div class="form-group">
                      <div class="row">
                        <div class="col-7">
                          <label class="cd-form-label">{{ $t('Color') }}</label>
                          <p class="cd-form-hint">{{ $t('Selecciona uno de los colores disponibles') }}</p>
                        </div>
                        <div class="col-5">
                          <label class="cd-form-label" style="margin-bottom: 0;">{{ $t('Vista previa') }}</label>
                          <!-- Always rendered (even with no name or colour
                               picked yet) so the block does not change height
                               while the form is being filled in. -->
                          <div class="tag-preview mb-2">
                            <span
                                v-if="formData.name && formData.css_class"
                                class="tag-badge"
                                :class="formData.css_class">
                              {{ formData.name }}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div class="color-picker-grid">
                        <!-- type="button" is required: the grid lives inside
                             the <form>, so a <button> without it would submit
                             the form when picking a colour. -->
                        <button
                            type="button"
                            v-for="color in colorOptions"
                            :key="color.value"
                            class="color-option"
                            :class="{ 'selected': formData.css_class === color.value }"
                            @click="formData.css_class = color.value">
                          <span class="color-box" :class="color.value"></span>
                          <span class="color-label">{{ color.label }}</span>
                          <span class="color-option__check">
                            <i class="fa fa-check"></i>
                          </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button
                      type="button"
                      class="btn btn-secondary"
                      @click="closeModal">
                    {{ $t('Cancelar') }}
                  </button>
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="saveTag"
                      :disabled="saving">
                    <i class="fa fa-spinner fa-spin" v-if="saving"></i>
                    {{ saving ? $t('saving') : $t('Guardar') }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Backdrop del modal -->
          <div
              v-if="showModal"
              class="modal-backdrop fade show"
              @click="closeModal">
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiCallList, dataTableLengthMenu, dataTableEsLanguage, enhanceDataTableLength } from '../../mixins'
import axios from 'axios'

export default {
  mixins: [apiCallList],

  data() {
    return {
      endpoint: 'conf/tags_types',
      section: 'conf_tags_types',
      tableData: [],
      saving: false,
      showModal: false,
      formData: {
        id: null,
        name: '',
        css_class: ''
      },
      colorOptions: [
        { value: 'badge-success', label: 'Verde' },
        { value: 'badge-danger', label: 'Rojo' },
        { value: 'badge-warning', label: 'Naranja' },
        { value: 'badge-yellow', label: 'Amarillo' },
        { value: 'badge-info', label: 'Azul' },
        { value: 'badge-purple', label: 'Morado' },
        { value: 'badge-pink', label: 'Rosa' },
        { value: 'badge-grey', label: 'Gris' },
        { value: 'badge-success2', label: 'Verde claro' },
        { value: 'badge-info2', label: 'Azul claro' },
        { value: 'badge-dark', label: 'Oscuro' }
      ]
    }
  },

  methods: {

    openCreateModal() {
      this.formData = {
        id: null,
        name: '',
        css_class: ''
      }
      this.showModal = true
      document.body.classList.add('modal-open')
    },

    editById(id) {
      const tag = this.data.find(item => item.id === id)
      if (tag) {
        this.formData = {
          id: tag.id,
          name: tag.name,
          category: tag.category,
          css_class: tag.css_class
        }
        this.showModal = true
        document.body.classList.add('modal-open')
      }
    },

    closeModal() {
      this.showModal = false
      document.body.classList.remove('modal-open')
    },

    async deleteTag(id) {
      if (!confirm(this.$t('¿Seguro que deseas borrar esta etiqueta?'))) {
        return
      }

      try {
        await axios.delete(`/${this.endpoint}/${id}`)

        this.$notify({
          type: 'success',
          message: this.$t('Etiqueta eliminada correctamente')
        })

        // 🔄 refrescar tabla
        await this.refreshTable()

      } catch (error) {
        this.$notify({
          type: 'danger',
          message:
              error.response?.data?.message ||
              this.$t('Error al borrar la etiqueta')
        })
      }
    },

    async fetchTags() {
      const { data } = await axios.get(`/${this.endpoint}`)
      this.data = data
      this.loadItems()
    },

    async refreshTable() {
      this.$store.dispatch ("isLoadingOn");
      //.location.reload(
      window.$('.table').DataTable().destroy()
      await this.fetchTags()
      this.$store.dispatch ("isLoadingOff");
    },

    async saveTag() {
      if (this.formData.category == '') {
        alert('Debes seleccionar una categoría');
        return;
      }

      if (!this.formData.name || !this.formData.category || !this.formData.css_class) {
        this.$notify({
          type: 'warning',
          message: this.$t('Por favor completa todos los campos')
        })
        return
      }

      this.saving = true

      try {
        const url = this.formData.id
            ? `/${this.endpoint}/${this.formData.id}`
            : `/${this.endpoint}`

        const method = this.formData.id ? 'put' : 'post'

        await axios[method](url, {
          name: this.formData.name,
          category: this.formData.category,
          css_class: this.formData.css_class
        })


        this.$notify({
          type: 'success',
          message: this.formData.id
              ? this.$t('Etiqueta actualizada correctamente')
              : this.$t('Etiqueta creada correctamente')
        })

        this.closeModal()

        // Recargar la lista
        //this.list()

        // 🔄 refrescar tabla
        await this.refreshTable()

      } catch (error) {
        console.error('Error al guardar:', error)

        // Mostrar mensaje de error más detallado
        const errorMsg = error.response?.data?.message
            || error.message
            || this.$t('Error al guardar la etiqueta')

        this.$notify({
          type: 'danger',
          message: errorMsg
        })
      } finally {
        this.saving = false
      }
    },

    loadItems() {
      // Mapear los datos sin HTML strings
      this.tableData = this.data.map(item => {
        return {
          id: item.id,
          name: item.name,
          category: item.category,
          css_class: item.css_class // Guardamos la clase CSS
        }
      })

      // Inicializar DataTable después de renderizar
      this.$nextTick(() => {
        if (window.$.fn.DataTable.isDataTable('.table')) {
          window.$('.table').DataTable().destroy()
        }

        window.$('.table').DataTable({
          pageLength: 10,
          lengthMenu: dataTableLengthMenu,
          language: dataTableEsLanguage,
          autoWidth: false,
          // Columnas que no se deben ordenar (acciones)
          columnDefs: [
            { orderable: false, targets: 4 }
          ]
        })
        enhanceDataTableLength()
      })
    }
  }
}
</script>

<style scoped>
.tag-badge {
  display: inline-block;
  padding: 0.35em 0.7em;
  font-size: 0.75rem;
  font-weight: 600;
  border-radius: 0.25rem;
  color: #fff;
}

.badge-success {
  background-color: #28a745;
}

.badge-danger {
  background-color: #dc3545;
}

/* Note: .badge-warning and .badge-yellow are not declared here because they
   are redefined with different values further down (final block of the file).
   Having them twice was only confusing to read — the browser was already
   keeping the later ones. */
.badge-info {
  background-color: #17a2b8;
}

.badge-purple {
  background-color: #6f42c1;
}

.badge-pink {
  background-color: #e83e8c;
}

.badge-dark {
  background-color: #343a40;
}

.btn-warning {
  cursor: pointer;
}

/* Preview: the badge sits on its own, with no surrounding panel. The min
   height matches the badge so the space stays reserved — without it the block
   grows the moment the badge appears and pushes the colour grid down. */
.tag-preview {
  display: flex;
  align-items: center;
  min-height: 28px;
}

/* Colour picker */
.color-picker-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}

@media (max-width: 575.98px) {
  .color-picker-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

.color-option {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.55rem 0.75rem;
  border: 1px solid var(--cd-border-green-soft, #cfe6d6);
  border-radius: 8px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.color-option:hover {
  border-color: var(--cd-brand-green-light, #6bc47d);
}

/* Bootstrap draws an outline on button:focus, which would also show up when
   picking a colour with the mouse. It is dropped here and focus is marked
   with :focus-visible only, same as the .cd-radio radios. */
.color-option:focus {
  outline: none;
}

.color-option:focus-visible {
  border-color: var(--cd-brand-green, #2E9E4F);
  box-shadow: 0 0 0 3px rgba(46, 158, 79, 0.2);
}

.color-option.selected {
  border-color: var(--cd-brand-green, #2E9E4F);
  background-color: var(--cd-surface-green-soft, #f2f8f3);
}

.color-box {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-right: 10px;
  border-radius: 6px;
}

.color-label {
  color: var(--cd-text-body, #4a4f5a);
  font-size: 0.9rem;
}

/* The check always takes up space (only its opacity changes) so the card does
   not reflow when it gets selected. */
.color-option__check {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  margin-left: auto;
  border-radius: 50%;
  background-color: var(--cd-brand-green, #2E9E4F);
  opacity: 0;
  transition: opacity 0.15s ease;
}

.color-option.selected .color-option__check {
  opacity: 1;
}

.color-option__check i {
  color: #fff;
  font-size: 10px;
}

/* Estilos para el modal controlado por Vue */
.modal.show {
  display: block !important;
}

/* This modal brings its own backdrop (hand-written Bootstrap markup, not the
   Modal.vue component), so .cd-modal .modal-mask does not cover it: the tint
   and opacity are matched here to the rest of the migrated modals. */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #212529;
}

.modal-backdrop.show {
  opacity: 0.35;
}

/****************************************************************************/
.table > thead > tr > th:nth-child(2)
{
  width: 25%;
 text-align: left !important;
}
.badge-info2{
  background-color: #60abc1;
}

.badge-success2{
  background-color: #B2C54A;
}

/* Dark text: on these two backgrounds (yellow and amber) the white that
   .tag-badge sets by default is unreadable. It used to come from a second
   declaration of these same classes higher up the file, now removed. */
.badge-yellow{
  background-color: #fcfc67;
  color: #212529;
}
.badge-warning{
  background-color: #FEBF00;
  color: #212529;
}
.badge-grey{
  background-color: #878686;
}
</style>